import { render, staticRenderFns } from "./AulaFormFooter.vue?vue&type=template&id=0fbf202a&scoped=true&"
import script from "./AulaFormFooter.vue?vue&type=script&lang=js&"
export * from "./AulaFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./AulaFormFooter.vue?vue&type=style&index=0&id=0fbf202a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf202a",
  null
  
)

export default component.exports